import React from 'react';
import L from 'leaflet';
import { Marker, Pane } from 'react-leaflet';

// Crisp HTML state labels (raster label tiles blur on high-DPI screens).
const STATES = [
  ['Alabama', 32.8, -86.8], ['Arizona', 34.3, -111.7], ['Arkansas', 34.9, -92.4],
  ['California', 37.25, -119.6], ['Colorado', 39.0, -105.55], ['CT', 41.62, -72.73],
  ['DE', 38.85, -75.4], ['Florida', 28.3, -81.7], ['Georgia', 32.65, -83.45],
  ['Idaho', 44.0, -114.7], ['Illinois', 40.06, -89.2], ['Indiana', 39.91, -86.27],
  ['Iowa', 42.08, -93.5], ['Kansas', 38.48, -98.38], ['Kentucky', 37.53, -85.29],
  ['Louisiana', 31.06, -92.2], ['Maine', 45.38, -69.23], ['MD', 39.25, -76.9],
  ['MA', 42.27, -71.84], ['Michigan', 43.6, -84.7], ['Minnesota', 46.32, -94.31],
  ['Mississippi', 32.75, -89.66], ['Missouri', 38.37, -92.48], ['Montana', 47.03, -109.65],
  ['Nebraska', 41.53, -99.81], ['Nevada', 39.35, -116.65], ['NH', 43.68, -71.58],
  ['NJ', 40.19, -74.66], ['New Mexico', 34.42, -106.11], ['New York', 42.94, -75.5],
  ['North Carolina', 35.54, -79.34], ['North Dakota', 47.45, -100.47], ['Ohio', 40.3, -82.79],
  ['Oklahoma', 35.5, -97.3], ['Oregon', 43.94, -120.56], ['Pennsylvania', 40.87, -77.8],
  ['RI', 41.6, -71.5], ['South Carolina', 33.9, -80.9], ['South Dakota', 44.44, -100.23],
  ['Tennessee', 35.84, -86.35], ['Texas', 31.5, -99.36], ['Utah', 39.33, -111.68],
  ['VT', 44.07, -72.66], ['Virginia', 37.51, -78.86], ['Washington', 47.37, -120.44],
  ['W. Virginia', 38.64, -80.62], ['Wisconsin', 44.64, -90.01], ['Wyoming', 43.0, -107.55],
];

const ICONS = STATES.map(([name]) =>
  L.divIcon({ className: 'state-label', html: `<span>${name}</span>`, iconSize: [0, 0] }),
);

export default function StateLabels() {
  return (
    <Pane name="state-labels" style={{ zIndex: 450, pointerEvents: 'none' }}>
      {STATES.map(([name, lat, lng], i) => (
        <Marker
          key={name}
          position={[lat, lng]}
          icon={ICONS[i]}
          interactive={false}
          keyboard={false}
          pane="state-labels"
        />
      ))}
    </Pane>
  );
}
